import i18n from "../i18n";
import appHelper from "@/assets/js/appHelper.js"
let _countryCodes = require('@/assets/data/validCountryCodes.json')
let _connectors = require('@/assets/data/connectors.json')
let _formatWhiteList = require('@/assets/data/formatWhiteList.json')
let _templateLanguages = require('@/assets/data/templateLanguages.json')

export default {
    activeTextEditor: null,
    sentenceBeingEdited: null,
    sentenceEditorPreview: null, // when editing a sentence, this is the preview shown in the right-side panel
    sentencePreviewPopoverIsBlocked: false,
    variantBeingEdited: null,
    templateSectionBeingEdited: null,
    templateSectionBeingNamed: "",
    templateSectionBeingNamedAndID: "",
    template: null,
    templatePreview: null, // this is the main preview
    templateVariables: [],
    variableFormats: null,
    activePath: [],
    user: null,
    users: [],
    apiKeys: [],
    scopes: [],
    organization: null,
    token: JSON.parse(localStorage.getItem("token")),
    templates: [],
    unsavedChanges: false,
    currentDatasetId: null,
    templateDataSearchResults: [],
    contentSources: [],
    contentSources2: [],
    dummyData: [],
    contentTypes: [],
    publicationStats: null,
    publicationSingleItemStats: [],
    apiUrl: appHelper.getApiUrl(),
    filters: [
      { name: i18n.t("home.all"), id: "all", categories: [], custom: "all" },
    ],
    formatWhiteList: _formatWhiteList,
    connectorSettings: [],
    exclusiveDropdown: null,
    dataFavorites: [],
    selectedDataset: "",
    templateMultiplePreview: [],
    templateMultipleDatasets: [],
    showTooltips: null,
    showingTemplateBackupInPreview: false,
    originalTemplateData: null,
    templateBackups: [],
    handlingExpiredToken: false,
    fixedConnectors: _connectors,
    subscriptionPlans: [],
    billingInfoTemporary: null,
    validCountryCodes: _countryCodes,
    // planExpired: false,
    loadingRoute: false,
    draggedVariant: null,
    draggedVariantList: null,
    sentenceDraggedFrom: null,
    draggedScenario: null,
    draggedSentencelist: null,
    scenarioIndex: null,
    draggingScenarioGroup: false,
    scrollToPath: false,
    templatePreviewAsHTML: false,
    templateLanguages: _templateLanguages,
    editorIsDemoVersion: false,
    // startDemoVersion: false,
    editorCtaContent: null,
    showEditorCta: false,
    demoData: null,
    temporaryDemoKey: null,
    temporaryLoginEmail: null,
    postDemoGuide: false,
    demoGuideSteps: [],
    demoGuideCurrentStep: null,
    showDemoGuide: false,
    userDevice: appHelper.getDeviceType(),
    tabletKeyboardFocus: null,
    demoFavoriteList: [],
    aiSectionsLoading: [],
    aiSectionPreviewError: [],
    autoRephraseVariantAmount: parseInt(localStorage.getItem("preferred-ai-variant-rephrase-amount")) || 3,
    loadingAIVariants: false,
    aiTranslationLanguage: null,
    synonymAmounts: 4
  }